import React, { ReactNode } from 'react';
import { t } from '@lingui/macro';

import { Button, ButtonProps, Flex, FlexProps } from '@rover/kibble/core';
import KibbleModal from '@rover/kibble/official-patterns/Modal';
import { isMobileBrowser } from '@rover/rsdk/src/modules/Network/userAgent';

import BottomSheet from './BottomSheet';

export type Props = {
  isOpen: boolean;
  onClose: (event?: any) => void;
  children: ReactNode | ReactNode[];
  hasCloseButton?: boolean;
  forceDesktop?: boolean;
  buttonVariant?: ButtonProps['variant'];
  sx?: FlexProps['sx'];
  headerText?: string;
};

// 552px = 600px (max modal width) - 48px (padding)
const MAX_MODAL_WIDTH = '552px';

const Modal = ({
  isOpen,
  onClose,
  hasCloseButton = true,
  children,
  forceDesktop = false,
  buttonVariant,
  sx = {},
  headerText,
}: Props): JSX.Element => {
  const isMobile = isMobileBrowser() && !forceDesktop;
  const RootComponent = isMobile ? BottomSheet : KibbleModal;

  const modalWidth = ['100%', MAX_MODAL_WIDTH];

  const desktopStyle: FlexProps['sx'] = {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: forceDesktop ? 'calc(100vh - 225px)' : 'calc(100vh - 80px)',
    boxSizing: 'content-box',
    paddingRight: '16px',
    border: 'none',
    outline: 'none',
  };

  const universalStyle = {
    paddingBottom: (hasCloseButton && (isMobile ? '48px' : '24px')) || (isMobile ? '0x' : '24px'),
  };

  const containerStyle: FlexProps['sx'] = {
    ...(!isMobile ? desktopStyle : {}),
    ...universalStyle,
    ...sx,
  };

  return (
    <RootComponent
      isOpen={isOpen}
      onRequestClose={onClose}
      {...(!isMobile && headerText ? { headerText } : {})}
    >
      <Flex flexDirection="column" alignItems="center" sx={containerStyle} width={modalWidth}>
        {children}
        <Flex
          position={isMobile ? 'absolute' : 'sticky'}
          left={isMobile ? '0px' : undefined}
          bottom={isMobile ? '24px' : '0px'}
          alignItems="center"
          justifyContent="center"
          width="100%"
          display={hasCloseButton ? 'flex' : 'none'}
        >
          <Button
            width={modalWidth}
            mx={isMobile ? '4x' : '1x'}
            onClick={onClose}
            variant={buttonVariant}
          >
            {t`Close`}
          </Button>
        </Flex>
      </Flex>
    </RootComponent>
  );
};

export default Modal;
